import React from "react";
import styles from "./style.module.css";

import { Button } from "aible";

import { VIEW_TYPE } from "containers/View/reducer";

import AibleLogo from "images/Aible_Logo/Aible_Collaborate_Stacked.svg";
import pathFind from "images/tileIcons/walkthrough-dark.svg";
import Tour from "reactour";

export default class CollaborateTour extends React.Component {
  // Hack so enter continues instead of closing tour
  hiddenUpdateStep(timeout) {
    const { step, updateStep } = this.props;

    document.getElementById("continueButton") &&
      document.getElementById("continueButton").children[0] &&
      document.getElementById("continueButton").children[0].click();

    return updateStep(step + 1);
  }

  render() {
    const { isOpen, step, updateIsOpen, updateStep, updateMode } = this.props;

    const steps = [
      {
        selector: "#mainApp",
        content: ({ goTo, inDOM }) => (
          <div className={styles.tContent}>
            <div className={styles.aibleLogo} style={{ width: "200px" }}>
              <img src={AibleLogo} style={{ width: "100%", height: "auto" }} />
            </div>
            <div className={styles.tHeader + " " + styles.centered}>{"Welcome to Aible Collaborate!"}</div>
            <div>
              {"Use Aible Collaborate to evaluate the AI projects within your " +
                "organization and add your feedback to help improve the AI performance. "}
            </div>
            <div style={{ marginTop: "20px" }}>
              {"Start the walkthrough to learn more. You can revisit this guide at any " +
                "time by clicking the walkthrough button in the header."}
            </div>
            <div className={styles.tFooter}>
              <Button
                type="primary"
                onClick={() => {
                  updateMode("DATA");
                  updateStep(step + 1);
                }}
              >
                {"Start the Walkthrough"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#menuTab_Datasets",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Data Feedback"}</div>
            <div>
              {"Review AI readiness, the column distribution, and quality issues " +
                "on available datasets from the Datasets tab"}
            </div>
            <div className={styles.tFooter}>
              <Button
                type="primary"
                onClick={() => {
                  updateMode("OVERVIEW");
                  updateStep(step + 1);
                }}
              >
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#menuTab_Projects",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Project Feedback"}</div>
            <div>
              {"Review a projects settings (business strategy and assumptions), " +
                "the expected impact, and scenarios that have been created from the Projects Tab"}
            </div>
            <div className={styles.tFooter}>
              <Button
                type="primary"
                onClick={() => {
                  updateMode("EXPAND_DETAILS");
                  return updateStep(step + 1);
                }}
              >
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#menuTab_Models",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"AI Model Feedback"}</div>
            <div>
              {"Review the relative strengths and key drivers for the AI models " +
                "being used in each project from the Models tab."}
            </div>
            <div className={styles.tFooter}>
              <Button
                type="primary"
                onClick={() => {
                  updateMode("MONITOR");
                  return updateStep(step + 1);
                }}
              >
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#menuTab_Monitoring",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Performance Monitoring Feedback"}</div>
            <div>
              {"If your organization has deployed AI into your business system, " +
                "you can review the actual impact it has had compared to its expected " +
                "impact from the Monitoring tab"}
            </div>
            <div className={styles.tFooter}>
              <Button type="primary" onClick={() => updateIsOpen(false)}>
                {"End Walkthrough"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      }
    ];

    return (
      <Tour
        steps={steps}
        isOpen={Boolean(isOpen)}
        onRequestClose={() => updateIsOpen(false)}
        goToStep={step}
        startAt={step}
        showNavigation={false}
        showButtons={false}
        closeWithMask={false}
        disableInteraction={false}
        rounded={5}
        accentColor={"#512e77"}
      />
    );
  }
}
